module.exports = __webpack_public_path__ + "static/offices-content-image-33@2x-429587a4cbfc8374d15ecf80a5e21edb.jpg";